import { FC } from 'react';
import {
  Text,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  Flex,
} from '@chakra-ui/react';
import { Element } from '../models';
import ElementDisplayItem from './DisplayItem';

type ElementsListProps = {
  elements: Element[] | undefined;
};

const ElementsList: FC<ElementsListProps> = ({ elements }) => {
  return (
    <Accordion allowMultiple mt="7">
      {elements?.map(element => (
        <AccordionItem
          bg="white"
          mb="2"
          border="none"
          rounded="md"
          boxShadow="md"
        >
          <h2>
            <AccordionButton
              py="3"
              _hover={{}}
              _focus={{}}
              _focusVisible={{ boxShadow: 'outline' }}
            >
              <Flex direction="column" alignItems="flex-start" w="full">
                <Box as="span" flex="1" fontSize="md" fontWeight="medium">
                  {element.name}
                </Box>
                <Text fontSize="sm" opacity="0.8">
                  {element.description}
                </Text>
              </Flex>
              <AccordionIcon />
            </AccordionButton>
          </h2>
          <AccordionPanel pb={4}>
            <Flex gridGap={4} wrap="wrap">
              {element.displays.map(display => (
                <ElementDisplayItem display={display} />
              ))}
            </Flex>
          </AccordionPanel>
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export default ElementsList;
